"use strict";
/*
 * Created on 01 02 2019
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var WeekDayRestriction_1 = require("../../model/constraint/WeekDayRestriction");

var WeekDayRestrictionConverter_1 = require("./WeekDayRestrictionConverter");
/**
 * @author Jaroslav Sevcik
 */


var WeekDayRestrictionConverterImpl =
/*#__PURE__*/
function (_WeekDayRestrictionCo) {
  _inherits(WeekDayRestrictionConverterImpl, _WeekDayRestrictionCo);

  function WeekDayRestrictionConverterImpl() {
    _classCallCheck(this, WeekDayRestrictionConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(WeekDayRestrictionConverterImpl).apply(this, arguments));
  }

  _createClass(WeekDayRestrictionConverterImpl, [{
    key: "toObject",

    /**
     * @inheritDoc
     */
    value: function toObject(source, conversions) {
      return new WeekDayRestriction_1.WeekDayRestriction(WeekDayRestriction_1.WeekDayRestriction.schema.days.valueOfField(source, 'days'));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, {
        days: conversions.asObjectArray(source, 'days', function (day) {
          return day;
        }),
        constraintType: source.getType()
      });
      return result;
    }
  }]);

  return WeekDayRestrictionConverterImpl;
}(WeekDayRestrictionConverter_1.WeekDayRestrictionConverter);

exports.WeekDayRestrictionConverterImpl = WeekDayRestrictionConverterImpl;